module.exports = __webpack_public_path__ + "static/media/Farmers-on-the-frontline-tablet.b27d12e5.jpg";